import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  newRevision: "",
  newRevisionWarMsg: "",
  newRevisionText: "",
  newRevisionObjCon: [],
};

const checkInNewRevisionSlice = createSlice({
  name: "checkin/checkInNewRevision",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase("ON_NEWREVISION_CHANGED", (state, action) => {
        state.newRevision = action.payload;
      })
      .addCase("ON_NEWREVISION_CHANGED_WAR_MSG", (state, action) => {
        state.newRevisionWarMsg = action.payload;
      })
      .addCase("ON_NEWREVISION_TEXT_CHANGED", (state, action) => {
        state.newRevisionText = action.payload;
      })
      .addCase("ON_NEWREVISION_OBJCON_CHANGED", (state, action) => {
        state.newRevisionObjCon = action.payload;
      });
  },
});

export default checkInNewRevisionSlice.reducer;
